import { render } from "./StoriesMainSlider.vue?vue&type=template&id=40334687&scoped=true"
import script from "./StoriesMainSlider.vue?vue&type=script&lang=js"
export * from "./StoriesMainSlider.vue?vue&type=script&lang=js"

import "./StoriesMainSlider.vue?vue&type=style&index=0&id=40334687&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40334687"]])

export default __exports__